export interface ILines {
    [key: string]: string[]
}

export const lines: ILines = {
    'A': ['002', '003', '007', '011', '015', '019'],
    'B': ['006', '010', '023', '027', '031', '035'],
    'C': ['039', '043', '047', '051', '055', '059'],
    'D': ['014', '018', '022', '026', '030', '034'],
    'E': ['038', '042', '046', '063', '067', '071'],
    'F': ['050', '054', '058', '062', '066', '070'],
    'G': ['049', '053', '057', '061', '065', '069'],
    'H': ['037', '041', '045', '060', '064', '068'],
    'I': ['036', '040', '044', '048', '052', '056'],
    'J': ['001', '005', '009', '024', '028', '032'],
    'K': ['000', '004', '008', '012', '016', '020'],
}
